export default "__VITE_ASSET__a2bc6f87__"